import { render, staticRenderFns } from "./TabStudents.vue?vue&type=template&id=d4b4f8fa"
import script from "./TabStudents.vue?vue&type=script&lang=js"
export * from "./TabStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports